import {
  Button,
  Modal,
  ModalBackdrop,
  ModalContainer,
  ModalDialog,
  useMediaQuery,
  useOverlayState,
} from '@heroui/react';
import { useNavigate } from '@tanstack/react-router';
import classNames from 'classnames';
import { ArrowUpRightIcon } from 'lucide-react';
import { useEffect } from 'react';

import { scrollToSection } from 'src/utils/scroll-to-section';

import { CloseButton } from './close-button';
import { Container } from './container';
import { FadeIn } from './fade-in';
import { Logo } from './logo';

const navLinks = [
  { label: 'Acerca', href: '#intro' },
  { label: 'Programa', href: '#programa' },
  { label: 'Regalos', href: '#regalos' },
];

export function Navbar() {
  const navigate = useNavigate();
  const menu = useOverlayState({ defaultOpen: false });

  const isMobile = useMediaQuery('(max-width: 768px)');
  useEffect(() => {
    if (!isMobile) {
      menu.close();
    }
  }, [isMobile, menu]);
  return (
    <nav className="bg-background/10 fixed top-0 right-0 left-0 z-50 py-4 backdrop-blur-md">
      <Container className="flex items-center justify-between">
        <h2
          className={classNames(
            'cursor-pointer',
            'font-ms-madi flex flex-1 items-center text-4xl transition-all duration-300'
          )}
          onClick={() => scrollToSection('hero', navigate)}
        >
          AC
        </h2>

        {/* Desktop nav */}
        <ul className="hidden flex-1 flex-row justify-center gap-6 md:flex">
          {navLinks.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                className="text-base uppercase hover:underline"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection(item.href, navigate);
                }}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>
        <div className="hidden flex-1 justify-end md:flex">
          <Button size="sm" onClick={() => navigate({ to: '/form' })}>
            Confirmar asistencia
            <ArrowUpRightIcon />
          </Button>
        </div>

        {/* Mobile hamburger */}
        <button className="-mr-2 flex flex-col gap-2 border-0 p-4 md:hidden" onClick={menu.open}>
          <div className="bg-foreground h-0.75 w-8 rounded-sm"></div>
          <div className="bg-foreground h-0.75 w-8 rounded-sm"></div>
        </button>

        <Modal isOpen={menu.isOpen} onOpenChange={menu.close}>
          <ModalBackdrop variant="blur">
            <ModalContainer placement="center" size="full">
              <ModalDialog className="flex flex-col bg-white/90 p-4">
                <div className="relative flex items-center justify-between">
                  <Logo />
                  <CloseButton onClick={menu.close} />
                </div>
                <FadeIn>
                  <div className="mt-18 flex flex-1 flex-col items-center gap-6">
                    <a
                      key="#hero"
                      href="#hero"
                      className="text-2xl uppercase"
                      onClick={(e) => {
                        e.preventDefault();
                        menu.close();
                        scrollToSection('hero', navigate);
                      }}
                    >
                      Inicio
                    </a>
                    {navLinks.map((item) => (
                      <a
                        key={item.href}
                        href={item.href}
                        className="text-2xl uppercase"
                        onClick={(e) => {
                          e.preventDefault();
                          menu.close();
                          scrollToSection(item.href, navigate);
                        }}
                      >
                        {item.label}
                      </a>
                    ))}
                    <a
                      key="/form"
                      href="/form"
                      className="text-2xl uppercase"
                      onClick={(e) => {
                        e.preventDefault();
                        menu.close();
                        navigate({ to: '/form' });
                      }}
                    >
                      Confirmar asistencia
                    </a>
                  </div>
                </FadeIn>
              </ModalDialog>
            </ModalContainer>
          </ModalBackdrop>
        </Modal>
      </Container>
    </nav>
  );
}
